@if (displayRooms().length > 0) {
	@for (room of displayRooms(); track room.guid) {
		<vp-persuade-card
			[cardUrl]="room.toUrl"
			[content]="room.summary"
			[ctaUrl]="room.ctaUrl"
			[iconList]="room.iconList"
			[images]="room.images"
			[overline]="room.hotelName"
			[price]="room.price"
			[pricingToolTip]="{ occupancy: room.pricingToolTip }"
			[showReadMore]="true"
			[title]="room.title"
			imageVariant="mini-carousel"
		/>
	}
} @else {
	<vp-alert
		[content]="
			'storyblok.pages.filterable-list.no-results.rooms-description'
				| translate
		"
		[emphasized]="true"
		[title]="'storyblok.pages.filterable-list.no-results.title' | translate"
		type="dialog--warning"
	/>
}
